import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import {
  CopyToClipboardButton,
  DetailsRow,
  IColumn,
  Link,
  ScrollablePane,
  ShimmeredDetailsListProps,
  Text
} from "@bps/fluent-ui";
import { IdentityIcon } from "@components/IdentityIcon";
import { ShimmeredDetailsList } from "@components/tables/ShimmeredDetailsList";
import { DeviceSummary } from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface DeviceSummaryTableProps extends ShimmeredDetailsListProps {}

export const DeviceSummaryTable = ({ ...props }: DeviceSummaryTableProps) => {
  const navigate = useNavigate();
  const columns: IColumn[] = useMemo(() => {
    return [
      {
        key: "identIcon",
        name: "",
        minWidth: 30,
        maxWidth: 30,
        isResizable: false,
        onRender: (deviceDetails: DeviceSummary) => (
          <IdentityIcon id={deviceDetails.id} />
        )
      },
      {
        key: "fieldDeviceId",
        name: "Field Device ID",
        minWidth: 100,
        maxWidth: 400,
        isResizable: true,
        onRender: (deviceDetails: DeviceSummary) => (
          <>
            <CopyToClipboardButton clipboardContent={deviceDetails.id} />
            <Link
              onClick={() =>
                navigate(`/field-mgmt/${deviceDetails.id}/fd-overview`)
              }
            >
              {deviceDetails.id}
            </Link>
          </>
        )
      },
      {
        key: "cloudConnectorId",
        name: "Cloud Connector ID",
        minWidth: 100,
        maxWidth: 400,
        isResizable: true,
        onRender: (deviceDetails: DeviceSummary) => (
          <CopyToClipboardButton
            clipboardContent={deviceDetails.cloudConnectorId}
            text={deviceDetails.cloudConnectorId}
          />
        )
      },

      {
        key: "computerName",
        name: "Computer Name",
        minWidth: 150,

        isResizable: true,
        onRender: (deviceDetails: DeviceSummary) => (
          <Text>{deviceDetails.computerName}</Text>
        )
      },

      {
        key: "installType",
        name: "Install Type",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onRender: (deviceDetails: DeviceSummary) => (
          <Text>
            {deviceDetails.installType === 0 && "Server"}
            {deviceDetails.installType === 1 && "Client"}
          </Text>
        )
      }
    ];
  }, [navigate]);

  return (
    <ScrollablePane styles={{ root: { height: 400, position: "relative" } }}>
      <ShimmeredDetailsList
        stickyHeader
        shimmerLines={5}
        columns={columns}
        onShouldVirtualize={() => true}
        onRenderRow={row => (row ? <DetailsRow {...row} /> : null)}
        {...props}
      />
    </ScrollablePane>
  );
};
